import React from "react";
import { ExclamationCircleIcon, ClockIcon } from "@heroicons/react/outline";

const MorningRateCard = ({ onSetRates, onDismiss }) => {
  const currentTime = new Date().toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <div className="bg-yellow-50 border-2 border-yellow-300 rounded-lg p-4 sm:p-6 shadow-lg">
      <div className="flex flex-col sm:flex-row sm:items-start">
        {/* Icon - Hidden on mobile, shown on tablet/desktop */}
        <ExclamationCircleIcon className="hidden sm:block h-6 sm:h-8 w-6 sm:w-8 text-yellow-600 mr-3 sm:mr-4 flex-shrink-0" />

        <div className="flex-1">
          <h3 className="text-base sm:text-lg font-bold text-yellow-900 flex items-center">
            <ClockIcon className="h-4 sm:h-5 w-4 sm:w-5 mr-1 sm:mr-2" />
            <span className="truncate">Morning Rate Check - {currentTime}</span>
          </h3>

          <p className="mt-2 text-xs sm:text-base text-yellow-800">
            Today's rates have not been set yet. Please set the rates for smooth
            business operations.
          </p>

          {/* Mobile: Stack buttons, Tablet/Desktop: Row */}
          <div className="mt-3 sm:mt-4 flex flex-col sm:flex-row gap-2 sm:gap-3">
            <button
              onClick={onSetRates}
              className="px-3 sm:px-4 py-2 bg-yellow-600 text-white rounded-lg 
                hover:bg-yellow-700 font-medium text-sm sm:text-base text-center
                transition-colors duration-200"
            >
              Set Today's Rates
            </button>
            <button
              onClick={onDismiss}
              className="px-3 sm:px-4 py-2 bg-white text-yellow-600 border border-yellow-300 
                rounded-lg hover:bg-yellow-50 text-sm sm:text-base text-center
                transition-colors duration-200"
            >
              Remind Me Later
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MorningRateCard;
